import { LIST_QUERY_CACHE_TTL_SECONDS, MATTER_ABOUT_TAG } from '@/api/constants';
import { api } from '@/api/core';
import type { CaseSource } from '@/api/cases/getCases';

export const MatterStatus = {
  NEW: 'NEW',
  UPLOADING: 'UPLOADING',
  UPLOADED: 'UPLOADED',
  UPLOAD_ERROR: 'UPLOAD_ERROR',
  EXTRACTING_CONTENT: 'EXTRACTING_CONTENT',
  GENERATING_CATEGORIES: 'GENERATING_CATEGORIES',
  GENERATING_CATEGORIES_COMPLETE: 'GENERATING_CATEGORIES_COMPLETE',
  GENERATING_INDEX: 'GENERATING_INDEX',
  GENERATING_INDEX_COMPLETE: 'GENERATING_INDEX_COMPLETE',
  INGESTION_COMPLETE: 'INGESTION_COMPLETE',
} as const;

export type MatterStatus = (typeof MatterStatus)[keyof typeof MatterStatus];

export interface MatterAboutResponse {
  info: {
    caseReference: string;
    clientName: string;
    defendantName: string | null;
    departmentName: string | null;
    fileHandlerName: string | null;
    /** Not on the backend yet. Until it ships, Case settings matches the handler by name. */
    fileHandlerId?: string | null;
    status: MatterStatus;
    teamName: string | null;
    hasProcessingDocuments: boolean;
    lastSyncedDatetime: string | null;
    /** Case reference is only editable when the case did not come from Proclaim. */
    source: CaseSource;
    /**
     * Not on the backend yet; the name matches `CaseData.isPasswordProtected`. Until it ships
     * it is always undefined and the case page shows no padlock.
     */
    isPasswordProtected?: boolean;
  };
}

export interface GetMatterAboutRequest {
  matterId: string;
}

const matterAboutApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMatterAbout: builder.query<MatterAboutResponse, GetMatterAboutRequest>({
      query: ({ matterId }) => ({
        url: '/matter/about',
        method: 'GET',
        params: {
          matter_id: matterId,
        },
      }),
      providesTags: (_result, _error, { matterId }) => [{ type: MATTER_ABOUT_TAG, id: matterId }],
      keepUnusedDataFor: LIST_QUERY_CACHE_TTL_SECONDS,
    }),
  }),
});

export const { useGetMatterAboutQuery, useLazyGetMatterAboutQuery } = matterAboutApi;
